export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TableAdvances.vue?vue&type=template&id=07488c7c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Advances/TableAdvances.vue?vue&type=template&id=07488c7c&scoped=true
// module id = 2377
// module chunks = 31